import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _QuizTitle;
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Heading } from '@instructure/ui-heading';
import { jsx } from '@instructure/emotion';
import makeScrollable from '../../../shared/functionality/makeScrollable';

// ==========================
// renders the quiz title on
// the Preview and Take pages
// ==========================

import generateStyle from './styles';
import generateComponentTheme from './theme';
import { withStyleOverrides } from '@instructure/quiz-common';
export var QuizTitle = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_QuizTitle = /*#__PURE__*/function (_Component) {
  function QuizTitle() {
    _classCallCheck(this, QuizTitle);
    return _callSuper(this, QuizTitle, arguments);
  }
  _inherits(QuizTitle, _Component);
  return _createClass(QuizTitle, [{
    key: "render",
    value: function render() {
      return jsx("div", {
        css: this.props.styles.wrapper,
        tabIndex: "-1"
      }, jsx(Heading, {
        level: "h1"
      }, jsx("span", {
        css: this.props.styles.text,
        "data-automation": "sdk-quiz-title-text"
      }, this.props.quiz.title)));
    }
  }]);
}(Component), _defineProperty(_QuizTitle, "displayName", 'QuizTitle'), _defineProperty(_QuizTitle, "componentId", "Quizzes".concat(_QuizTitle.displayName)), _defineProperty(_QuizTitle, "propTypes", {
  quiz: ImmutablePropTypes.record.isRequired,
  styles: PropTypes.object
}), _QuizTitle)) || _class);
export default makeScrollable(QuizTitle);